<template>
    <div class="kgk-user-run-create">
        <h3 v-if="!insideModal">
            Lauf eintragen
        </h3>
        <div v-if="!edit || !detailsLoading">
            <form @submit.prevent="createRun">
                <div class="kgk-form-row">
                    Gelaufene Distanz
                    <div class="kgk-input-group">
                        <div class="kgk-input-group-append">km</div>
                        <input type="text" v-model="form.length">
                    </div>
                    <div v-if="!lengthFormatValidation" class="kgk-form-validation-error-inline">Fehlerhafte Eingabe</div>
                    <div v-if="!lengthValueValidation" class="kgk-form-validation-error-inline">Maximal {{this.maximumLengthValue}} Kilometer</div>
                    <div v-if="showValidationErrors && !lengthRequiredValidation" class="kgk-form-validation-error-inline">Bitte gib eine Laufdistanz an.</div>
                </div>
                <div class="kgk-form-row">
                    Gelaufene Zeit
                    <div class="kgk-input-group">
                        <div class="kgk-input-group-prepend">
                            <i class="fas fa-stopwatch fa-fw"></i>
                        </div>
                        <input type="number" v-model="form.duration.hours" placeholder="hh" min="0" max="23" step="1" maxlength="2">
                        <input type="number" v-model="form.duration.minutes" placeholder="mm" min="0" max="59" step="1" maxlength="2">
                        <input type="number" v-model="form.duration.seconds" placeholder="ss" min="0" max="59" step="1" maxlength="2">
                    </div>
                    <div v-if="!durationValueValidation" class="kgk-form-validation-error-inline">Ungültige Zeit</div>
                    <div v-if="showValidationErrors && !durationRequiredValidation" class="kgk-form-validation-error-inline">Bitte gib eine Laufdauer an</div>
                    <!--div v-if="form.length.length > 0 && form.length.length < 5">Bitte geben Sie mindestens 5 Zeichen ein.</div-->
                </div>
                <div class="kgk-form-row">
                    Pace
                    <div class="kgk-input-group">
                        <div class="kgk-input-group-append">min/km</div>
                        <input type="text" :value="convertNumberReadable(pace)" placeholder="Bitte Distanz und Zeit eingeben" disabled>
                    </div>
                </div>
                <div class="kgk-form-row">
                    Datum
                    <div class="kgk-input-group">
                        <div class="kgk-input-group-prepend">
                            <i class="fas fa-calendar-alt fa-fw"></i>
                        </div>
                        <Datetime
                                type="date"
                                format="dd.LL.yy"
                                value-zone="UTC+2"
                                zone="UTC+2"
                                v-model="form.ran_at.date"
                                inputClass="form-control text-center"
                                auto
                                :min-datetime="minDatetime"
                                :max-datetime="maxDatetime"
                                :phrases="{cancel: 'Abbrechen', ok: 'Übernehmen'}">
                        </Datetime>
                    </div>
                    <div v-if="showValidationErrors && !ranAtDateRequiredValidation" class="kgk-form-validation-error-inline">Bitte gib ein Datum an.</div>
                </div>
                <div class="kgk-form-row">
                    Startzeit
                    <div class="kgk-input-group">
                        <div class="kgk-input-group-prepend">
                            <i class="fas fa-clock fa-fw"></i>
                        </div>
                        <Datetime
                                type="time"
                                format="HH:mm 'Uhr'"
                                value-zone="UTC+2"
                                zone="UTC+2"
                                v-model="form.ran_at.time"
                                inputClass="form-control text-center"
                                auto
                                :minute-step="5"
                                :phrases="{cancel: 'Abbrechen', ok: 'Übernehmen'}">
                        </Datetime>
                    </div>
                    <div v-if="showValidationErrors && !ranAtTimeRequiredValidation" class="kgk-form-validation-error-inline">Bitte gib eine Startzeit an.</div>
                </div>
                <div class="spacer-small"></div>
                <div class="kgk-form-row">
                    <p v-if="isInvalidated" class="kgk-error">
                        <i class="fas fa-exclamation-triangle"></i>
                        Dein hochgeladenes Nachweisfoto wurde als unzureichend eingestuft. Bitte lade einen ausreichenden Nachweis hoch.
                    </p>
                    <div v-if="form.screenshot_url" class="kgk-upload-preview">
                        <img :src="form.screenshot_url">
                    </div>
                    <ImageUpload type="run" @uploaded="handleFileUploaded" :button-icon="'fas fa-camera'" :button-text="'Nachweisfoto ' + (form.screenshot_url ? 'ersetzen' : 'hochladen')" />
                    <p>
                        Dateigröße max. 5 MB
                    </p>
                    <p v-if="!form.screenshot_url && this.competitive !== null">
                        <i class="fas fa-info-circle"></i>&nbsp;
                        <span v-if="this.competitive">
                            Solange du keinen bildlichen Nachweis (Foto/Screenshot) hochlädst, wird dein Lauf nicht in die Wertung mit einbezogen, da du den Wettbewerb-Modus aktiviert hast.
                        </span>
                        <span v-else>
                            Da du den Wettbewerb-Modus nicht aktiviert hast, benötigst du keinen Bildnachweis.
                        </span>
                        <!--
                        <span v-if="runScreenshotRequired">
                            Solange du keinen bildlichen Nachweis (Foto/Screenshot) hochlädst, wird dein Lauf nicht in die Wertung mit einbezogen.
                        </span>
                        <span v-else>Der Upload eines Bildnachweises ist <b>nicht mehr verpflichtend</b>, dein Lauf wird auch ohne Nachweis gewertet.</span>
                        -->
                    </p>
                </div>
                <div v-if="!insideModal" class="kgk-form-row">
                    <button type="submit">
                        <i v-if="loading" class="fas fa-spinner fa-spin"></i>
                        <span class="button-text">Lauf eintragen</span>
                    </button>
                </div>
            </form>
        </div>
        <div v-else-if="edit && detailsLoading" class="kgk-loading-indicator"><i class="fas fa-spinner fa-spin"></i></div>
    </div>
</template>

<script>
    import runs from '../../api/runs';

    import { Datetime } from 'vue-datetime';
    import ImageUpload from './ImageUpload';
    import user from '@/api/user';

    const lengthRegex = /^\s*\d+([.,]\d+)?\s*$/; // basically int or float value with comma or dot separator

    export default {
        name: 'CreateRunForm',
        components: {
            Datetime,
            ImageUpload,
        },
        props: {
            edit: {
                type: Boolean,
                required: true
            },
            insideModal: {
                type: Boolean,
                required: true,
                default: false,
            },
            modalSaveTrigger: {
                type: Object,
                required: false
            },
            runIdentifier: {
                type: String,
                required: false
            },
        },
        data() {
            return {
                competitiveLoading: false,
                detailsLoading: false,
                loading: false,
                competitive: null,
                form: {
                    editIdentifier: null,
                    length: '',
                    duration: {
                        hours: '',
                        minutes: '',
                        seconds: '',
                    },
                    ran_at: {
                        date: '',
                        time: '',
                    },
                    run_type:0,
                    screenshot_url: null,
                },
                isInvalidated: false,
                screenshotIsNew: false,
                screenshotExtension: null,
                showValidationErrors: false,
                minDatetime: '2025-04-01T00:00:00Z', // @TODO: read from window.kgkConfig ?
                maxDatetime: (new Date()).toISOString(),
                error: '',
                maximumLengthValue: 50000, // @Todo: read from window.kgkConfig
            }
        },
        computed: {
            runScreenshotRequired() {
                if( typeof window.kgkConfig === 'undefined' || typeof window.kgkConfig.runScreenshotRequired === 'undefined' ) {
                    return true; // default is YES, screenshot is required
                }

                return !!window.kgkConfig.runScreenshotRequired;
            },
            lengthRequiredValidation() {
                const lengthTrimmed = this.form.length.trim();

                return lengthTrimmed.length > 0;
            },
            lengthFormatValidation() {
                const lengthTrimmed = this.form.length.trim();

                if( lengthTrimmed.length == 0 ) {
                    return true;
                }

                return lengthRegex.test(lengthTrimmed);
            },
            lengthFloat() {
                const lengthTrimmed = this.form.length.trim();

                if( lengthTrimmed.length == 0 ) {
                    return 0;
                }

                if( !this.lengthFormatValidation ) {
                    return 0;
                }

                return Math.abs(parseFloat(lengthTrimmed.replace(',', '.')));
            },
            lengthValueValidation() {
                return this.lengthFloat < this.maximumLengthValue;
            },

            durationHoursInt() {
                if( this.form.duration.hours === null || this.form.duration.hours.trim().length == 0 ) {
                    return 0;
                }
                const parsed = parseInt(this.form.duration.hours);
                return isNaN(parsed) ? -1 : parsed;
            },
            durationMinutesInt() {
                if( this.form.duration.minutes.trim().length == 0 ) {
                    return 0;
                }
                const parsed = parseInt(this.form.duration.minutes);
                return isNaN(parsed) ? -1 : parsed;
            },
            durationSecondsInt() {
                if( this.form.duration.seconds.trim().length == 0 ) {
                    return 0;
                }
                const parsed = parseInt(this.form.duration.seconds);
                return isNaN(parsed) ? -1 : parsed;
            },
            durationValueValidation() {
                if( this.durationHoursInt < 0 || this.durationHoursInt > 23 ) {
                    return false;
                }
                if( this.durationMinutesInt < 0 || this.durationMinutesInt > 59 ) {
                    return false;
                }
                if( this.durationSecondsInt < 0 || this.durationSecondsInt > 59 ) {
                    return false;
                }

                return true;
            },
            durationRequiredValidation() {
                return this.durationInSeconds > 0;
            },

            durationInSeconds() {
                return Math.max(0, this.durationHoursInt) * 60 * 60 + Math.max(0, this.durationMinutesInt) * 60 + Math.max(0, this.durationSecondsInt);
            },

            ranAtDateRequiredValidation() {
                return !!this.form.ran_at.date;
            },
            ranAtTimeRequiredValidation() {
                return !!this.form.ran_at.time;
            },

            pace() {
                if( this.lengthFloat <= 0 || (this.durationHoursInt < 1 && this.durationMinutesInt < 1 && this.durationSecondsInt < 1 ) ) {
                    return '';
                }

                return Math.round((this.durationInSeconds / 60) / this.lengthFloat * 100) / 100;
            },
        },
        methods: {
            loadUserCompetitiveState() {
                this.competitiveLoading = true;

                user.getDetails(
                    this,
                    data => {
                        this.competitive = data.user.competitive;
                    },
                    () => console.warn('Es ist ein Fehler aufgetreten'),
                    () => this.competitiveLoading = false,
                );
            },
            createRun(/*calledFromModal*/) {
                //calledFromModal = calledFromModal || false;

                if( this.loading ) {
                    return;
                }

                this.showValidationErrors = true;

                if( !this.lengthRequiredValidation
                    || !this.lengthFormatValidation
                    || !this.lengthValueValidation
                    || !this.durationRequiredValidation
                    || !this.durationValueValidation
                    || !this.ranAtDateRequiredValidation
                    || !this.ranAtTimeRequiredValidation ) {
                    this.$notify({
                        type: 'warn',
                        title: 'Eingaben fehlerhaft.',
                        text: 'Bitte korrigiere deine Formulareingaben.'
                    });

                    return;
                }

                this.loading = true;

                //if( calledFromModal ) {
                    this.$emit('loadingStarted');
                //}

                const data = JSON.parse(JSON.stringify(this.form));

                // prepare data
                data.length = this.lengthFloat;
                data.duration = this.durationInSeconds;

                // convert date+time to SQL datetime format
                data.ran_at = data.ran_at.date.split('T')[0] + ' ' + data.ran_at.time.split(/T|\./)[1];

                data.screenshot_uploaded = this.screenshotIsNew;
                data.screenshot_extension = this.screenshotExtension;

                if( !this.edit ) {
                    runs.create(
                        this,
                        data,
                        () => {
                            this.$notify({
                                type: 'success',
                                title: 'Lauf eingetragen',
                                text: `Dein Lauf wurde erfolgreich erstellt.`
                            });

                            this.$emit('created');
                        },
                        e => {
                            //console.error(e.response.status);
                            if( e.response.status == 400 ) {
                                /*if( typeof e.response.data.field !== 'undefined' ) {
                                    // maybe highlight error field
                                }*/

                                this.$notify({
                                    type: 'error',
                                    title: 'Fehler',
                                    text: e.response.data.message
                                });
                                return;
                            }

                            this.$notify({
                                type: 'error',
                                title: 'Es ist ein unbekannter Fehler aufgetreten.',
                                text: 'Bitte versuch es noch einmal.'
                            });
                        },
                        () => {
                            this.loading = false;
                            //if( calledFromModal ) {
                                this.$emit('loadingEnded');
                            //}
                        }
                    );
                }
                else {
                    delete data.editIdentifier;
                    data.identifier = this.form.editIdentifier;

                    runs.update(
                        this,
                        data,
                        () => {
                            this.$notify({
                                type: 'success',
                                title: 'Lauf bearbeitet',
                                text: `Dein Lauf wurde erfolgreich gespeichert.`
                            });

                            this.$emit('edited');
                        },
                        e => {
                            //console.error(e.response.status);
                            if( e.response.status == 400 ) {
                                /*if( typeof e.response.data.field !== 'undefined' ) {
                                    // maybe highlight error field
                                }*/

                                this.$notify({
                                    type: 'error',
                                    title: 'Fehler',
                                    text: e.response.data.message
                                });
                                return;
                            }

                            this.$notify({
                                type: 'error',
                                title: 'Es ist ein unbekannter Fehler aufgetreten.',
                                text: 'Bitte versuch es noch einmal.'
                            });
                        },
                        () => {
                            this.loading = false;
                            //if( calledFromModal ) {
                                this.$emit('loadingEnded');
                            //}
                        }
                    );
                }

                return true;
            },

            handleFileUploaded(url, ext) {
                this.form.screenshot_url = url + '?' + (new Date().getTime());
                this.screenshotIsNew = true;
                this.screenshotExtension = ext;
            },

            loadCurrentTimeInForm(){
                this.form.ran_at.date = (new Date()).toISOString();
                this.form.ran_at.time = (new Date()).toISOString();
                
            }
        },
        watch: {
            'modalSaveTrigger.trigger'() {
                this.createRun();
                /*const result = this.createRun(true);
                if( result === true ) {

                }*/
            },
        },
        mounted() {
            this.loadUserCompetitiveState();
            this.loadCurrentTimeInForm();

            if( this.edit ) {
                if( !this.runIdentifier ) {
                    console.error('CreateRunForm edit mode requires passing of a run identifier');
                    return;
                }

                this.detailsLoading = true;

                runs.get(
                    this,
                    this.runIdentifier,
                    ({run}) => {
                        this.form.editIdentifier = run.identifier;
                        this.form.length = this.convertNumberReadable(run.length);

                        this.form.duration.hours   = '' + Math.floor(run.duration / 60 / 60);
                        /*if( this.form.duration.hours === '0' ) {
                            this.form.duration.hours = null;
                        }*/
                        this.form.duration.minutes = '' + Math.floor((run.duration % (60 * 60)) / 60);
                        this.form.duration.seconds = '' + run.duration % 60;

                        this.form.ran_at.date = run.ran_at.split(' ')[0] + 'T00:00:00.000';
                        this.form.ran_at.time = (new Date().toJSON()).split('T')[0] + 'T' + run.ran_at.split(' ')[1] + '.000';

                        this.form.screenshot_url = run.screenshot_url;

                        this.isInvalidated = !!run.invalidated;
                    },
                    () => {
                        this.$notify({
                            type: 'error',
                            title: 'Es ist ein unbekannter Fehler aufgetreten.',
                            text: 'Bitte versuch es noch einmal.'
                        });

                        if( this.insideModal ) {
                            this.$emit('modalForceClose');
                        }
                    },
                    () => this.detailsLoading = false,
                );
            }


        }
    }
</script>

